import { render } from "./Button.vue?vue&type=template&id=3e5b0792&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=3e5b0792&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5b0792"],['__file',"src/assets/js/components/Form/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e5b0792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e5b0792', __exports__)) {
    api.reload('3e5b0792', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=3e5b0792&scoped=true", () => {
    api.rerender('3e5b0792', render)
  })

}


export default __exports__